import { gql } from '@apollo/client';
import { COMPONENT_FRAGMENTS, MODULE_FRAGMENTS } from './fragments';

const getDefaultTaggedContentFilter = () => `{
          AND:[
            {contentfulMetadata: {
              tags_exists: true
              tags: {
                id_contains_some: $groupId
              }
            }},
            {contentfulMetadata: {
              tags_exists: true
              tags: {
                id_contains_some: $nativeTagIds
              }
            }},
          ]
        }`;

const createCategoriesFilterString = () => {
  let filterString = '';
  for (let i = 0; i < 5; i += 1) {
    filterString = `${filterString} {contentfulMetadata: {
              tags_exists: true
              tags: {
                id_contains_some: $category${i}
              }
            }},`;
  }
  return filterString;
};
const getFilteredTaggedContentFilter = () => `{
          AND:[
            {contentfulMetadata: {
              tags_exists: true
              tags: {
                id_contains_some: $groupId
              }
            }},
            ${createCategoriesFilterString()}
          ]
        }`;

const getTaggedItemsString = () => `{
        total
        items {
          contentfulMetadata {
            tags {
              id
              name
            }
          }
          slug
          navigationTag {
            title
            slug
          }
          meta {
            image {
              ...image
            }
          }
          hero {
            title
            foregroundImage {
              ...image
            }
          }
        }
      }`;

const getTaggedTileString = () => `{
        total
        items {
          sys {
            id
          }
          contentfulMetadata {
            tags {
              id
              name
            }
          }
          title
          description
          eyebrow
          image {
            ...image
          }
          backgroundColor
          textColor
          themeSelector
          audio {
            ...Audio
          }
          overlay {
            sys {
              id
            }
          }
        }
      }`;

const initialTaggedContentString = () => `(
        where: ${getDefaultTaggedContentFilter()}
        limit: $limit
        skip: $skip
      )${getTaggedItemsString()}`;

const initialTaggedContentTileString = () => `(
        where: ${getDefaultTaggedContentFilter()}
        limit: $limit
        skip: $skip
      )${getTaggedTileString()}`;

const filteredTaggedContentString = () => `(
        where: ${getFilteredTaggedContentFilter()}
        limit: $limit
        skip: $skip
      )${getTaggedItemsString()}`;

const filteredTaggedContentTileString = () => `(
        where: ${getFilteredTaggedContentFilter()}
        limit: $limit
        skip: $skip
      )${getTaggedTileString()}`;

export const GET_INITIAL_TAGGED_CONTENT = ({ locale = '' }) => gql`
    query GetInitialContent(
        $nativeTagIds: [String],
        $groupId: [String],
        $skip: Int,
        $limit: Int) {
      pageDetailCollection: pageDetail${locale}Collection${initialTaggedContentString()}
      pageDetailGlobalCollection: pageDetailGlobalCollection${initialTaggedContentString()}
      taggedContentTileCollection: taggedContentTileCollection${initialTaggedContentTileString()}
    }
    ${COMPONENT_FRAGMENTS.IMAGE}
    ${MODULE_FRAGMENTS.AUDIO}
  `;

export const GET_FILTERED_TAGGED_CONTENT = ({ locale = '' }) => gql`
    query GetTaggedContent($category0: [String], $category1: [String], $category2: [String], $category3: [String], $category4: [String],
        $groupId: [String],
        $skip: Int,
        $limit: Int) {
      pageDetailCollection: pageDetail${locale}Collection${filteredTaggedContentString()}
      pageDetailGlobalCollection: pageDetailGlobalCollection${filteredTaggedContentString()}
      taggedContentTileCollection: taggedContentTileCollection${filteredTaggedContentTileString()}
    }
    ${COMPONENT_FRAGMENTS.IMAGE}
    ${MODULE_FRAGMENTS.AUDIO}
  `;
